module.exports = __webpack_public_path__ + "img/icon_bottom_1.5d77573d.png";